import { addMilliseconds } from 'date-fns'
import { batch } from 'react-redux'
import { putCookie } from '@chilecompra/react-kit'
import { makeActionCreator } from '../../config/store/utils'
import { getAuthInfo, getPublicToken } from '../../services/auth'

export const GET_PUBLIC_TOKEN = 'GET_PUBLIC_TOKEN'
export const GET_PUBLIC_TOKEN_ERROR = 'GET_PUBLIC_TOKEN_ERROR'
export const GET_PUBLIC_TOKEN_SUCCESS = 'GET_PUBLIC_TOKEN_SUCCESS'
export const onGetPublicToken = makeActionCreator(GET_PUBLIC_TOKEN)
export const onGetPublicTokenError = makeActionCreator(GET_PUBLIC_TOKEN_ERROR, 'payload')
export const onGetPublicTokenSuccess = makeActionCreator(GET_PUBLIC_TOKEN_SUCCESS, 'payload')
export const onGetPublicTokenThunk = () => async dispatch => {
  dispatch(onGetPublicToken())

  try {
    const { data } = await getPublicToken()
    const expiresAt = addMilliseconds(new Date(), data.payload?.expires_in * 1000)

    putCookie('access_token', data.payload?.access_token, {
      expires: expiresAt
    })

    return batch(() => {
      dispatch(onGetPublicTokenSuccess())
      dispatch(onGetAuthInfoThunk())
    })
  } catch (error) {
    return dispatch(
      onGetPublicTokenError({
        error: {
          code: error.code,
          message: error.reason
        }
      })
    )
  }
}

export const GET_AUTH_INFO = 'GET_AUTH_INFO'
export const GET_AUTH_INFO_ERROR = 'GET_AUTH_INFO_ERROR'
export const GET_AUTH_INFO_SUCCESS = 'GET_AUTH_INFO_SUCCESS'
export const onGetAuthInfo = makeActionCreator(GET_AUTH_INFO)
export const onGetAuthInfoError = makeActionCreator(GET_AUTH_INFO_ERROR, 'payload')
export const onGetAuthInfoSuccess = makeActionCreator(GET_AUTH_INFO_SUCCESS, 'payload')
export const onGetAuthInfoThunk = () => async dispatch => {
  dispatch(onGetAuthInfo())

  try {
    const { data } = await getAuthInfo()

    return dispatch(
      onGetAuthInfoSuccess({
        authInfo: {
          orgCode: data?.payload?.codigoOrganismo || '',
          userCode: data?.payload?.codigoUsuario || '',
          userName: data?.payload?.name || data?.payload?.preferred_username,
          userType: data?.payload?.tipoUsuario || 'Publico',
          sellerDni: data?.payload?.rut || ''
        }
      })
    )
  } catch (error) {
    if (error.code === 401 || error.code === 403) {
      return dispatch(onGetPublicTokenThunk())
    }

    return dispatch(
      onGetAuthInfoError({
        error: {
          code: error.code,
          message: error.reason
        }
      })
    )
  }
}
